import React from 'react';
import { useSelector } from 'react-redux';

import { selectSiteUrl } from 'core/selectors/app';

function ProductDetailsLink({
  id, keywords, name, children, useClickUrl, clickUrl, className,
}) {
  const siteUrl = useSelector(selectSiteUrl);

  if (useClickUrl) {
    return (
      <a
        className={className || 'mn_prodDetails'}
        href={clickUrl}
        target="_blank"
        title={`Opens a new window at ${name}`}
        data-test="product-click-link"
      >
        {children}
      </a>
    );
  }

  return (
    <a
      className={className || 'mn_prodDetailsLink'}
      href={`${siteUrl}/pd____.htm?pid=${id}${ (keywords && keywords.length) ? `&keywords=${keywords}` : '' }`}
      title={`Learn more about ${name}`}
      data-test="product-details-link"
    >
      {children}
    </a>
  );
}

ProductDetailsLink.defaultProps = {
  id: '',
  keywords: '',
  name: '',
  clickUrl: '',
  useClickUrl: false,
};

export default ProductDetailsLink;
